<template>
<div style="white-space: nowrap; display: inline-block;">
	<button class="btn button_tiefox_light" v-on:click="changeElementShow"><span v-if="typeof icon !== 'undefined'" :class="icon" /> {{$t(scope+'.values.'+id)}}</button>
	<modal-input @change-element="changeElement"
		@close-modal="showModal = false" :get="get"
		:scope="scope" :modalid="'modal-'+id"
		:datatype="datatype" :id="id" :title="$t(scope+'.values.'+id)" :scopeSelect ="scope"
		v-if="showModal"></modal-input>		
</div>
</template>

<script>
import ModalInput from "@/components/input/ModalInput.vue";
export default {
  name: "ButtonModalInput",
  components: {
	    ModalInput
  },
  data() {
    return {
      showModal: false
    };
  },
  props: ["id", "data", "scope", "get", "set", "datatype", "icon"],
  methods: {	  
    changeElementShow() {
      this.showModal = true;
      this.$nextTick(() => {
        $("#modal-" + this.id).modal("show");
      });
    },
    changeElement() {
      var modal = "#modal-" + this.id;
      $(modal + " .button_tiefox_dark")
        .addClass("disabled")
        .prop("disabled", true);
      $(modal + " .wait").removeClass("hidden");

      var value = $(modal + " option:selected").val();
      var text = $(modal + " option:selected").text();
      var optgroup = $(modal + " option:selected").parent().attr('label');
            
      if(this.set !== undefined) {
	      axios
	        .post(this.set, {
	          key: this.id,
	          value: value
	        })
	        .then(response => {
	          $(modal + " .button_tiefox_dark")
	            .removeClass("disabled")
	            .prop("disabled", false);
	          $(modal + " .wait").addClass("hidden");
	          if (response.data.status === true) {        	
	        	this.$emit('value-add', value, text, optgroup);              
	            $(modal).modal("hide");
	            this.showModal = false;
	          } else {
	            $(modal + " .error")
	              .html("<b>"+ this.$t('misc.errors.' + response.data.status, {attribute:this.$t(this.scope+'.values.'+this.id)}) +"</b>")
	              .removeClass("hidden");
	          }
	        }).catch(error => {
		       	$(modal + " .wait").addClass("hidden");
			   	if (error.response) {
			   		$(modal + " .error").html("<b>"+this.$t('misc.errorServerResponse', {status:error.response.status})+"</b>").removeClass("hidden");
			    } else if (error.request) {
			       	$(modal + " .error").html("<b>"+this.$t('misc.errorNoServerResponse', {status:error.response.status})+"</b>").removeClass("hidden");
			    } 
		 	});
       } else {
    	   this.$emit('value-add', value, text, optgroup);  
           $(modal).modal("hide");
           this.showModal = false;
       }
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/input/ButtonModalInput.vue